import React, { useState, useEffect, useCallback, useRef } from 'react';
import ResizableDrawerView from '../view/ResizableDrawerView';

const ResizableDrawerEngine = ({
  open,
  anchor = 'right',
  children,
  padding = '0.8em',
  onClose,
  drawerWidth: givenDrawerWidth = '42em',
  isMobile,
  ...props // material ui drawer props
}) => {
  const [drawerWidth, setDrawerWith] = useState(givenDrawerWidth);
  const [isDraggerStyleEnabled, setIsDraggerStyleEnabled] = useState(false);
  const isResizing = useRef(false);

  // this function has to be here so the rendering will take effect (might as well use useCallback)
  const handleMouseDown = useCallback(() => {
    isResizing.current = true;
    setIsDraggerStyleEnabled(true);
  }, []);

  const handleMousemove = useCallback(
    e => {
      if (!isResizing.current) {
        return;
      }

      let offsetRight =
        document.body.offsetWidth - (e.clientX - document.body.offsetLeft);
      if (offsetRight > document.body.offsetWidth * 0.9) {
        offsetRight = Math.floor(document.body.offsetWidth * 0.9);
      }
      setDrawerWith(offsetRight + 'px');
    },
    [isResizing]
  );

  useEffect(() => {
    document.addEventListener('mousemove', e => handleMousemove(e));
    document.addEventListener('mouseup', () => {
      isResizing.current = false;
      setIsDraggerStyleEnabled(false);
    });
  }, []);

  const viewProps = {
    open,
    onClose,
    anchor,
    drawerWidth,
    children,
    isMobile,
    isResizing: isResizing.current,
    handleMouseDown,
    isDraggerStyleEnabled
  };

  return <ResizableDrawerView {...viewProps} {...props} />;
};

export default ResizableDrawerEngine;
